"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timeDifferenceBetweenDates = exports.setupHooks = exports.processUrls = exports.loadScript = exports.hmsToSeconds = exports.formatTime = exports.appendURLParams = void 0;
var _video = _interopRequireDefault(require("video.js"));
var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));
var _isNull = _interopRequireDefault(require("lodash/isNull"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _moment = _interopRequireDefault(require("moment"));
var _defaultConfig = require("./config/defaultConfig");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Utility function to append signed url parameters to passed in url
 *
 * More info: https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/private-content-signed-urls.html
 *            https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/private-content-creating-signed-url-canned-policy.html
 *
 * @param {string} url  
 *        Request URL
 * 
 * @param {Object} params
 *        URL parameters to be appended
 * 
 *        @param {String} Signature
 *        A hashed, signed, and base64-encoded version of the JSON policy statement
 * 
 *        @param {String} Key-Pair-Id
 *        The ID for an active CloudFront key pair
 *
 *        @param {String} Policy
 *        Policy statement in JSON format, with white space removed, then base64 encoded
 */

var appendURLParams = exports.appendURLParams = function appendURLParams(url, params) {
  var returnUrl = "";
  //return empty string if url is invalid
  if ((0, _isUndefined["default"])(url) || (0, _isEmpty["default"])(url) || (0, _isNull["default"])(url)) {
    return returnUrl;
  }
  //return incoming url if no params object present
  if ((0, _isUndefined["default"])(params) || (0, _isEmpty["default"])(params) || (0, _isNull["default"])(params)) {
    return url;
  }
  var authParamString = "Signature=" + params.Signature + "&Key-Pair-Id=" + params['Key-Pair-Id'] + "&Policy=" + params.Policy;
  var urlString = url.split("?")[0];
  var paramString = url.split("?")[1];
  var paramsToAppend = "";

  //first we need to check if the url contains any params
  if ((0, _isUndefined["default"])(paramString)) {
    //if it doesn't, let's append the auth params now and we're done
    returnUrl = urlString + "?" + authParamString;
  } else {
    //otherwise, let's loop through the params and strip the auth params if they exist
    //we'll add them back while preserving any other params
    //this is to handle the case where query params may have been added to a request
    //outside of our control
    var paramArray = paramString.split("&");
    paramArray.forEach(function (keyValue) {
      var key = keyValue.split("=")[0];
      if (key !== "Signature" && key !== "Key-Pair-Id" && key !== "Policy") {
        if (paramsToAppend === "") {
          paramsToAppend += "?" + keyValue;
        } else {
          paramsToAppend += "&" + keyValue;
        }
      }
    });
    if (paramsToAppend !== "") {
      returnUrl = urlString + paramsToAppend + "&" + authParamString;
    } else {
      returnUrl = urlString + "?" + authParamString;
    }
  }
  return returnUrl;
};

/**
* convert a string with format hh:mm:ss to seconds
*
* @return {number}
*         time in seconds
*/
var hmsToSeconds = exports.hmsToSeconds = function hmsToSeconds(time) {
  return _moment["default"].duration(time).asSeconds();
};

/**
* Converts date input strings (begin, end) to date objects and 
* calculates the difference.  Return value is in seconds.

* @return {number} time in seconds
*/
var timeDifferenceBetweenDates = exports.timeDifferenceBetweenDates = function timeDifferenceBetweenDates(begin, end) {
  if (!begin || !end) return 0;
  var beginDate = (0, _moment["default"])(begin);
  var endDate = (0, _moment["default"])(end);
  var diff = endDate.diff(beginDate);
  return diff / 1000;
};

/**
* Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in seconds)
* will force a number of leading zeros to cover the length of the guide.
*
* @param {number} seconds
*        Number of seconds to be turned into a string
*
* @param {number} guide
*        Number (in seconds) to model the string after
*
* @return {string}
*         Time formatted as H:MM:SS or M:SS
*/
var formatTime = exports.formatTime = function formatTime(seconds, guide) {
  seconds = seconds < 0 ? 0 : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600);

  // handle invalid times
  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = m = s = '-';
  }

  // Check if we need to show hours
  h = h > 0 || gh > 0 ? h + ':' : '';

  // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.
  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';

  // Check if leading zero is need for seconds
  s = s < 10 ? '0' + s : s;
  return h + m + s;
};

/**
*
* Intercept all outgoing requests from video player
* and append signed url parameters
*
*        @param {object} player
*        player object
*        @param {string} config
*        A config object which includes auth params Signature, Key-Pair-Id, and Policy
*
*/
var setupHooks = exports.setupHooks = function setupHooks(player, config) {
  if (config.auth === _defaultConfig.AuthTypes.PARAM) {
    player.on('loadstart', function () {
      if (!_video["default"] || !_video["default"].Vhs) return null;
      var globalXhrRequestHook = function globalXhrRequestHook(options) {
        options.uri = appendURLParams(options.uri, config.params);
        return options;
      };
      _video["default"].Vhs.xhr.onRequest(globalXhrRequestHook);
    });
  }
  return null;
};

/**
 * set up source list based on configuration type
 * if we are using cookie based auth,
 * we need to add the withCredentials attribute to each URL
 * otherwise, append url parameters
 * 
 * @param {array} urls
 * @param {object} config
 * @returns updated url list
*/

var processUrls = exports.processUrls = function processUrls(urls, config) {
  var urlCopy = _toConsumableArray(urls);
  var auth = config.auth,
    params = config.params;
  if (auth === _defaultConfig.AuthTypes.COOKIE) {
    urlCopy.forEach(function (url) {
      url.withCredentials = true;
    });
  } else {
    urlCopy.forEach(function (url) {
      url.src = appendURLParams(url.src, params);
    });
  }
  return urlCopy;
};

/**
 *
 * load scripts asynchronously
 *
 * @param {*} src source of script
 */
var loadScript = exports.loadScript = function loadScript(src) {
  return new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.async = true;
    s.addEventListener('error', function (err) {
      return reject(err);
    });
    s.addEventListener('load', function () {
      return resolve();
    });
    var t = document.getElementsByTagName('script')[0];
    t.parentElement.insertBefore(s, t);
  });
};